"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var _ThemeManager = _interopRequireDefault(require("../../../managers/ThemeManager"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

// This HOC cannot be stateless, because we need state to track whether the element is too short
// and is truncated or not, as well as keep the full text for title attribute
// Generate non-truncated state
var stateNonTruncated = function stateNonTruncated() {
  return {
    isTruncated: false,
    fullText: ''
  };
}; // Generate truncated state


var stateTruncated = function stateTruncated(el) {
  return function (_ref) {
    var fullText = _ref.fullText;
    return {
      isTruncated: true,
      fullText: el.textContent
    };
  };
};
/**
 * HOC for truncating text to available space with ellipsis (ending ...) and showing
 * full content in a hover tooltip if needed.
 *
 * @param {ReactComponent} Component Component that will be extended with truncation capabilities
 * @return {ReactComponent} Extended Component definition
 */


function Truncate(Component) {
  // Class definition for the truncated component
  // Class is not named here because classname is generated dynamically at end of this file
  var TruncateComponent =
  /*#__PURE__*/
  function (_React$Component) {
    _inherits(TruncateComponent, _React$Component);

    /**
    * @override
    * HOC constructor
    * @param {Object} props Initial properties of the HOC and wrapped component
    */
    function TruncateComponent(props) {
      var _this;

      _classCallCheck(this, TruncateComponent);

      _this = _possibleConstructorReturn(this, _getPrototypeOf(TruncateComponent).call(this, props));
      _this.state = stateNonTruncated();
      _this.handleMouseEnter = _this.handleMouseEnter.bind(_assertThisInitialized(_this));
      return _this;
    }
    /**
     * Handle event when mouse enters wrapped component visible area
     * @param {Event} e DOM event
     */


    _createClass(TruncateComponent, [{
      key: "handleMouseEnter",
      value: function handleMouseEnter(e) {
        // Get DOM element of interest
        var el = e.target; // See https://stackoverflow.com/questions/21064101/understanding-offsetwidth-clientwidth-scrollwidth-and-height-respectively
        // for a good explanation of scrollWidth and clientWidth and why this comparison does the trick.

        if (el.scrollWidth > el.clientWidth) {
          // If not enough room to show everything, truncate and register full text for tooltip
          this.setState(stateTruncated(el));
        } else {
          // If enough room to show everything, don't truncate and just render as-is
          this.setState(stateNonTruncated());
        }
      }
      /**
       * @override
       * Render React compoment
       * @return {Component} Wrapped component with HOC logic added to it
       */

    }, {
      key: "render",
      value: function render() {
        var _this2 = this;

        var _this$state = this.state,
            isTruncated = _this$state.isTruncated,
            fullText = _this$state.fullText;

        var _this$props = this.props,
            children = _this$props.children,
            className = _this$props.className,
            onMouseEnter = _this$props.onMouseEnter,
            props = _objectWithoutProperties(_this$props, ["children", "className", "onMouseEnter"]); // Combine this component's classnames with the ones passed in props if any


        var mergedClassName = (0, _classnames.default)("".concat(_ThemeManager.default.getVar('classPrefix'), "-truncate ").concat(_ThemeManager.default.getVar('classPrefix')), className); // onMouseEnter can be passed when instantiating the component, in that case it has to be
        // called in addition to internal handleMouseEnter method

        var mergedOnMouseEnter = function mergedOnMouseEnter() {
          _this2.handleMouseEnter.apply(_this2, arguments);

          if (typeof onMouseEnter === 'function') {
            return onMouseEnter.apply(void 0, arguments);
          }
        }; // If the text is truncated, add title attribute


        var truncateProps = isTruncated ? {
          title: fullText
        } : {}; // Instantiate the wrapped component

        return _react.default.createElement(Component, _extends({
          className: mergedClassName,
          onMouseEnter: mergedOnMouseEnter
        }, truncateProps, props), children);
      }
    }]);

    return TruncateComponent;
  }(_react.default.Component); // Determine name of component
  // If it is a DOM component (<span>, <div>, ...) it's given as string directly
  // otherwise, the .name property of the component class should be set


  var componentName = typeof Component === 'string' || Component instanceof String ? Component.charAt(0).toUpperCase() + Component.slice(1) : Component.name; // Set the name of the truncated component class

  Object.defineProperty(TruncateComponent, 'name', {
    value: "Truncate".concat(componentName)
  }); // Provide the parameterized truncated component class

  return TruncateComponent;
}
/**
 * @component
 */


var _default = Truncate;
exports.default = _default;